import { validateHttpsUrl } from '../../../../../../../../../Utils';
import { CUSTOM_LINK_FIELDS } from '../../../../../../constants';
import { CUSTOM_LINK_VALIDATION_ERROR_MESSAGES } from './constants';

export const getUrlValidationErrorMessage = (url) => {
  if (!url) {
    return CUSTOM_LINK_VALIDATION_ERROR_MESSAGES.URL.REQUIRED;
  }

  if (!validateHttpsUrl(url)) {
    return CUSTOM_LINK_VALIDATION_ERROR_MESSAGES.URL.INVALID;
  }
};

export const getValidationErrorMessages = (title, url) => {
  const errorMessages = {};

  if (!title) {
    errorMessages[CUSTOM_LINK_FIELDS.TITLE] =
      CUSTOM_LINK_VALIDATION_ERROR_MESSAGES.TITLE.REQUIRED;
  }

  const urlErrorMessage = getUrlValidationErrorMessage(url);
  if (urlErrorMessage) {
    errorMessages[CUSTOM_LINK_FIELDS.URL] = urlErrorMessage;
  }

  return Object.values(errorMessages).length ? errorMessages : null;
};
